import * as React from 'react';
import { Dispatch } from 'react-redux';

import { HeaderButton } from '../Header/styles';
import { StyleColor } from '../../../utils/styles-constants';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { toggleEditPanel } from '../../../containers/Editor/actions';
import { IGNORE_PAGE_CLICK_CLASSNAME, SPREAD_BACKGROUND_CLICK_CLASSNAME } from '../../../containers/Editor/constants';

interface ButtonEditProps {
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonEdit = ({ isDisabled, dispatch }: ButtonEditProps) => (
	<HeaderButton
		className={`${IGNORE_PAGE_CLICK_CLASSNAME} ${SPREAD_BACKGROUND_CLICK_CLASSNAME}`}
		iconWidth="35px"
		iconHeight="35px"
		disabled={isDisabled}
		color={isDisabled ? StyleColor.White : StyleColor.Blue600}
		onClick={() => dispatch(toggleEditPanel())}
	>
		{Utils.getSvgIcon('iconset_uprez_edit')}
	</HeaderButton>
);

export default ButtonEdit;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonEdit/index.tsx